export function normalizeAmount(amount) {
  if (typeof amount === 'number') {
    return amount;
  }
  return amount ? +amount.replace(/\s+/g, '') : 0;
}
